var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-dialog',{staticClass:"notice",attrs:{"title":_vm.title,"closable":false,"btns":_vm.niticebtns},model:{value:(_vm.noticeopen),callback:function ($$v) {_vm.noticeopen=$$v},expression:"noticeopen"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49e4dff4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notice.vue
// module id = null
// module chunks = 